// extracted by mini-css-extract-plugin
module.exports = {"productCardTags":"tags_productCardTags__d_IpC"};